export enum AppActionType {
  CONTACT = "CONTACT",
  PORTAL_NEWS = "PORTAL_NEWS",
  PROJECT_TEAM_INVITATIONS = "PROJECT_TEAM_INVITATIONS",
  OPEN_COOKIE_BANNER = "OPEN_COOKIE_BANNER",
  DELETE_PROFILE = "DELETE_PROFILE",
  VISITOR_LOGIN = "VISITOR_LOGIN",
  LOGIN = "LOGIN"
}
